import React from 'react';

import {
    FaHtml5,
    FaCss3,
    FaJs,
    FaBootstrap,
    FaNodeJs,
    SiNodemon,
    FaReact,
    SiCplusplus,
    FaPython,
    SiFlask,
    DiMysql,
    DiMongodb,
    DiMaterializecss,
    DiPhotoshop,
    DiIllustrator,
    SiAdobexd,
    FaFigma,

} from 'react-icons/all';

const skillCardContent = [
    {
        icon: <FaHtml5 />,
        title: 'HTML5',
        text: 'HTML5 é uma linguagem de marcação para a World Wide Web e é uma tecnologia chave da Internet.',
        level: 4
    },
    {
        icon: <FaCss3 />,
        title: 'CSS3',
        text: 'Cascading Style Sheets é um mecanismo para adicionar estilo a um documento web.',
        level: 3
    },
    {
        icon: <FaJs />,
        title: 'JavaScript',
        text: 'JavaScript é uma linguagem de programação interpretada estruturada, de script em alto nível com tipagem dinâmica fraca e multiparadigma.',
        level: 3
    },
    {
        icon: <FaBootstrap />,
        title: 'Bootstrap',
        text: 'Bootstrap é um framework web com código-fonte aberto para desenvolvimento de componentes de interface e front-end para sites e aplicações web usando HTML, CSS e JavaScript.',
        level: 3
    },
    {
        icon: <FaNodeJs />,
        title: 'Node.js',
        text: 'Node.js trata-se de um software open-source, cross-platform, e de um runtime de JavaScript que execute código de JavaScript a nível backend e frontend.',
        level: 2
    },
    {
        icon: <SiNodemon />,
        title: 'Nodemon',
        text: 'Nodemon é um utilitário que monitora quaisquer mudanças em sua fonte e automaticamente reinicia seu servidor. Perfeito para desenvolvimento.',
        level: 2
    },
    {
        icon: <FaReact />,
        title: 'React',
        text: 'O React é uma biblioteca JavaScript de código aberto com foco em criar interfaces de usuário em páginas web.',
        level: 2
    },
    {
        icon: <SiCplusplus />,
        title: 'C++',
        text: 'C++ é uma linguagem de programação compilada multi-paradigma e de uso geral.',
        level: 4
    },
    {
        icon: <FaPython />,
        title: 'Python',
        text: 'Python é uma linguagem de programação de alto nível, interpretada, de script, imperativa, orientada a objetos, funcional, de tipagem dinâmica e forte.',
        level: 4
    },
    {
        icon: <SiFlask />,
        title: 'Flask Framework',
        text: 'Flask é um pequeno framework web escrito em Python e baseado na biblioteca WSGI Werkzeug e na biblioteca de Jinja2.',
        level: 3
    },
    {
        icon: <DiMysql />,
        title: 'MySQL',
        text: 'O MySQL é um sistema de gerenciamento de banco de dados, que utiliza a linguagem SQL como interface.',
        level: 3
    },
    {
        icon: <DiMongodb />,
        title: 'MongoDB',
        text: 'MongoDB é um software de banco de dados orientado a documentos livre, de código aberto e multiplataforma, escrito na linguagem C++.',
        level: 2
    },
    {
        icon: <DiMaterializecss />,
        title: 'Materialize',
        text: 'Materialize é um framework de front-end responsiva e moderno baseado no Material Design (Google)',
        level: 3
    },
    {
        icon: <DiPhotoshop />,
        title: 'Adobe Photoshop',
        text: 'Adobe Photoshop é um software caracterizado como editor de imagens bidimensionais do tipo raster desenvolvido pela Adobe Systems.',
        level: 5
    },
    {
        icon: <DiIllustrator />,
        title: 'Adobe Illustrator',
        text: 'Adobe Illustrator é um editor de imagens vetoriais desenvolvido e comercializado pela Adobe Systems.',
        level: 4
    },
    {
        icon: <FaFigma />,
        title: 'Figma',
        text: 'Figma é um editor de gráficos vetoriais e uma ferramenta de prototipagem baseada principalmente na web, com recursos offline adicionais ativados por aplicativos de desktop para macOS e Windows.',
        level: 3
    }
];

export default skillCardContent;